import { guiCreatorDataStore, storageKey } from '../stores/guiCreatorData';
import './storage.services.types';
import '../stores/types';
import { uiElementOf } from '../utils/helpers';
const configParserMap = {
    0: updateConfigFromVersionZeroToOne,
    1: updateConfigFromVersionOneToTwo,
    2: updateConfigFromVersionTwoToThree,
    3: updateConfigFromVersionTreeToFour,
    4: updateConfigFromVersionFourToFive
};
const latestConfigVersion = Object.keys(configParserMap).length;
export function parseDataToSaveConfig(data) {
    return {
        configVersion: 5,
        data: data,
    };
}
export function saveConfig(elementsStoreData) {
    const saveObj = parseDataToSaveConfig(elementsStoreData);
    localStorage.setItem(storageKey, JSON.stringify(saveObj, null, 2));
}
export function loadConfig() {
    const rawData = localStorage.getItem(storageKey);
    if (rawData) {
        const loadedGuiCreatorData = parseRawData(rawData);
        guiCreatorDataStore.set(loadedGuiCreatorData);
    }
}
export function parseRawData(rawData) {
    let parsedValue = JSON.parse(rawData);
    if (!parsedValue.configVersion) {
        console.warn('No config Version found');
    }
    else {
        console.info(`Got config file with version ${parsedValue.configVersion}`);
    }
    while (parsedValue.configVersion !== latestConfigVersion) {
        const currentVersion = parsedValue.configVersion || 0;
        const targetVersion = currentVersion + 1;
        console.info(`Parsing info from version ${currentVersion} to version ${targetVersion}`);
        if (parsedValue.configVersion === undefined) {
            parsedValue = configParserMap[0](parsedValue);
        }
        else {
            parsedValue = configParserMap[parsedValue.configVersion](parsedValue);
        }
    }
    let loadedAndParsedData = parsedValue;
    let guiCreatorData = { pages: {}, currentPage: '', projectName: '' };
    guiCreatorData.currentPage = parsedValue.data.currentPage;
    guiCreatorData.pages = Object.keys(loadedAndParsedData.data.pages).reduce((pages, pageKey) => {
        const currentPage = loadedAndParsedData.data.pages[pageKey];
        pages[pageKey] = {};
        pages[pageKey].swipeable = currentPage.swipeable;
        pages[pageKey].elements = Object.keys(currentPage.elements).reduce((pageElements, elementId) => {
            const loadedElement = currentPage.elements[elementId];
            pageElements[loadedElement.id] = uiElementOf(loadedElement);
            return pageElements;
        }, {});
        return pages;
    }, {});
    guiCreatorData.projectName = parsedValue.data.projectName;
    return guiCreatorData;
}
export function updateConfigFromVersionZeroToOne(configData) {
    let data = configData;
    if (Array.isArray(configData)) {
        data = configData.reduce((map, entry) => {
            map[entry.id] = entry;
            return map;
        }, {});
    }
    return {
        configVersion: 1,
        data: data,
    };
}
export function updateConfigFromVersionOneToTwo(configData) {
    return {
        configVersion: 2,
        data: { currentPage: 'Page 1', pages: { 'Page 1': configData.data } },
    };
}
export function updateConfigFromVersionTwoToThree(configData) {
    const v3Data = {
        configVersion: 3,
        data: {
            currentPage: configData.data.currentPage,
            pages: {},
        },
    };
    Object.keys(configData.data.pages).forEach(pageKey => {
        v3Data.data.pages[pageKey].elements = configData.data.pages[pageKey];
    });
    return v3Data;
}
export function updateConfigFromVersionTreeToFour(configData) {
    return {
        configVersion: 4,
        data: {
            projectName: 'Bangle.js GUi',
            currentPage: configData.data.currentPage,
            pages: configData.data.pages,
        },
    };
}
export function updateConfigFromVersionFourToFive(configData) {
    Object.keys(configData.data.pages).forEach(pageKey => {
        configData.data.pages[pageKey].swipeable = configData.data.pages[pageKey].swipeable || false;
    });
    return {
        configVersion: 5,
        data: {
            projectName: 'Bangle.js GUi',
            currentPage: configData.data.currentPage,
            pages: configData.data.pages,
        },
    };
}
